export default __webpack_public_path__ + "static/media/calendar_teacher_icon.7a6905ec.svg";